module.exports = __webpack_public_path__ + "img/payslip.4a1f5316.svg";